import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "arv-reactcomponents";
import AccordionContents from "../AccordionContents";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { valueFromObjectComposition } from "../../../utils";
import { PDP_CONFIG } from "npmlinks-constants";

class MobileAccordion extends Component {
  static activeButton(isOpen) {
    return isOpen ? "is-active" : "";
  }
  constructor(props) {
    super(props);

    this.state = {
      buttons: [],
    };
    this.buttons = PDP_CONFIG.ACCORDION_CONFIG.MOBILE_ACCORDION;
    this.setActive = this.setActive.bind(this);
    this.revampAccordion = this.revampAccordion.bind(this);
    this.getActiveAccordion = this.getActiveAccordion.bind(this);
  }
  componentDidMount() {
    this.revampAccordion(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.revampAccordion(nextProps);
  }

  getActiveAccordion(index) {
    const { PdpData } = this.props;
    const { buttons } = this.state;
    const RenderComponent =
      buttons[index] &&
      AccordionContents[buttons[index].type] &&
      AccordionContents[buttons[index].type];
    if (RenderComponent) {
      return <RenderComponent.component PdpData={PdpData} className="" />;
    }

    return null;
  }

  setActive(event, index) {
    event.preventDefault();
    const { buttons } = this.state;
    buttons[index].isOpen = !buttons[index].isOpen;
    this.setState({ buttons });
    Analytics.trackEvent({
      action: Event.action.getTabClicked(buttons[index].type),
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
  }

  componentDidCatch(error, info) {
    console.log(this, error, info);
  }

  revampAccordion(props) {
    const { PdpData: { mainStyle } } = props;

    const buttons = this.buttons.filter(
      item =>
        valueFromObjectComposition(mainStyle, item.keyToBeChecked) ||
        valueFromObjectComposition(mainStyle, item.keyToBeChecked) === false,
    );
    this.setState({
      buttons,
    });
  }
  render() {
    const { PdpData } = this.props;
    if (!this.state.buttons || this.state.buttons.length === 0) {
      return null;
    }
    return (
      <div className="nw-pdp-mobileaccordionwrap nw-mobile-only">
        <div className="nw-pdp-mobileaccordionbuttonwrap">
          {this.state.buttons.map(
            (button, index) =>
              (button.isShown && (
                <div key={button.type}>
                  <Button
                    className={`nw-pdp-mobileaccordionbutton ${MobileAccordion.activeButton(
                      button.isOpen,
                    )}`}
                    onClick={e => this.setActive(e, index)}
                  >
                    <i
                      className={`icomoon-arrow_right nw-mobileaccordion-rightarrow ${MobileAccordion.activeButton(
                        button.isOpen,
                      )}`}
                    />
                    <span>
                      {button.text.replace(
                        "%brand%",
                        PdpData.mainStyle.brandName,
                      )}
                    </span>
                  </Button>
                  <div
                    className={`nw-pdp-mobileaccordionbuttoncontent ${MobileAccordion.activeButton(
                      button.isOpen,
                    )}`}
                  >
                    {this.getActiveAccordion(index)}
                  </div>
                </div>
              )) ||
              null,
          )}
        </div>
      </div>
    );
  }
}
MobileAccordion.propTypes = {
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      about: PropTypes.shape({
        brandName: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: MobileAccordion,
  component: MobileAccordion,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PdpAccordion/Mobile/index.js